<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/customers/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/customers/${this.$route.params.id}/edit`,
                    },
                    {
                        title: 'Заказы',
                        url: `/customers/${this.$route.params.id}/orders`,
                    },
                    {
                        title: 'Личные промокоды',
                        url: `/customers/${this.$route.params.id}/promocodes`,
                    },
                ],
            };
        },
    };
</script>
